__turbopack_context__.v({
  "description": "poster-module__8xj-bq__description",
  "header": "poster-module__8xj-bq__header",
  "left": "poster-module__8xj-bq__left",
  "navigateButton": "poster-module__8xj-bq__navigateButton",
  "pattern": "poster-module__8xj-bq__pattern",
  "poster": "poster-module__8xj-bq__poster",
  "posterWrapper": "poster-module__8xj-bq__posterWrapper",
  "right": "poster-module__8xj-bq__right",
  "shevron": "poster-module__8xj-bq__shevron",
  "text": "poster-module__8xj-bq__text",
  "timeCard": "poster-module__8xj-bq__timeCard",
  "title": "poster-module__8xj-bq__title",
});
